import { useStaticQuery, graphql } from "gatsby"

export  const useStrapiLatestWebinarsData = () => {
    const { allStrapiVideo } = useStaticQuery(graphql`
        query {
          allStrapiVideo(filter: {title: {regex: "/Peer Support: A Path to Hope and Family Recovery|How to Use Data for Change: Improving Outcomes for Families Affected by Substance Use/"}}) {
            nodes {
              title
              strapi_id
              slug
              thumbnail {
                alternativeText
                localFile {
                  childImageSharp {
                    gatsbyImageData(layout: FULL_WIDTH)
                  }
                }
              }
            }
          }
        }
      `)
    return { allStrapiVideo }
}
